import { render, staticRenderFns } from "./RoleModules.vue?vue&type=template&id=050a9bf0&scoped=true"
import script from "./RoleModules.vue?vue&type=script&lang=js"
export * from "./RoleModules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050a9bf0",
  null
  
)

export default component.exports